import { useWindowDimensions } from '../../../hooks';

const NAV_BAR_HEIGHT = 90;

export default function PbiIframe({ pbiUrl }: { pbiUrl: string }) {
  const { height } = useWindowDimensions();

  return (
    <iframe
      title='RGMTower DEV'
      width='100%'
      height={`${height - NAV_BAR_HEIGHT}px`}
      src={pbiUrl}
      frameBorder='0'
      allowFullScreen
    />
  );
}
